import React from "react";
import "./index.css";
import Button from "../../components/button/button";

const Contact: React.FC = () => {
  const fullYear = new Date();
  const year = fullYear.getFullYear();

  return (
    <div className="contact_page">
      <h1>Let’s create something together</h1>
      <p>
        The best programs are written so that computing machines can perform
        them quickly and so that human beings can understand them clearly. A
        programmer is ideally an essayist who works with traditional aesthetic
        and literary forms as well as mathematical concepts, to communicate the
        way that an algorithm works and to convince a reader that the results
        will be correct. - <b>Donald E. Knuth</b>
      </p>
      <a href="mailto: nwekecharles5@gmail.com">
        <Button label="Say Hello" />
      </a>
      <div className="footer">
        <p>Copyright {year} | Nweke Charles | All rights reserved</p>
      </div>
    </div>
  );
};

export default Contact;
